module.exports = "/images/extra-third-party.svg?942a9b5ddab615b189096d7ce1e8a279";